import Model from '@/models/Model.js';
import Role, { INSTRUCTOR } from '@/models/Role.js';

export default class UserGroup extends Model {
    static entity = 'user_groups';

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            group_id: this.attr(null),
            role_id: this.attr(null),

            ...super.fields(),

            user: this.belongsTo('users', 'user_id'),
            group: this.belongsTo('groups', 'group_id'),
            role: this.belongsTo('roles', 'role_id'),
        };
    }

    get courseIds() {
        if (this.group?.courses) {
            return this.group.courses.map(course => course.id);
        }

        if (this._courseIds) {
            return this._courseIds;
        }
        return [];
    }

    async fetchCourseIds() {
        try {
            const response = await this.constructor.api().get(`user-groups/${this.id}/course-ids`);
            const courseIds = response.data.data.course_ids || [];
            this._courseIds = courseIds;

            return courseIds;
        } catch (_error) {
            return [];
        }
    }

    hasCourse(courseId) {
        return this.courseIds.includes(courseId);
    }

    async hasCourseAsync(courseId) {
        const courseIds = await this.fetchCourseIds();
        const hasAccess = courseIds.includes(courseId);

        return hasAccess;
    }

    hasInstructorRole() {
        return this.role_id === INSTRUCTOR;
    }

    hasPermissionTo(permission) {
        return Role.query().with('permissions').find(this.role_id).hasPermissionTo(permission);
    }

    static async getCourseIds(userGroupId) {
        try {
            const response = await this.api().get(`user-groups/${userGroupId}/course-ids`);
            const courseIds = response.data.data.course_ids || [];

            return courseIds;
        } catch (error) {
            console.error(`[UserGroup] Failed to fetch course IDs for user group ${userGroupId}:`, error);
            return [];
        }
    }
}
